import { useEffect, useState } from 'react'

export function useAsyncInitialize<T>(
  func: () => Promise<T>,
  deps: unknown[] = [],
): T | undefined {
  const [state, setState] = useState<T | undefined>()
  useEffect(() => {
    ;(async () => {
      setState(await func())
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps -- its right deps
  }, deps)

  return state
}
